export default __webpack_public_path__ + "static/media/bg-1.3d76f399.jpg";